import { createContext } from 'react';
import type { UserViewContextProviderValue } from './types';

const UserViewContextContext = createContext<UserViewContextProviderValue | null>(null);

export default UserViewContextContext;
